import {useContext, useEffect, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AuthContext from "context/AuthContext";
import AssetBasic from "./AssetBasic";
import WasteTypesSelect from "./WasteTypesSelect";
import DownloadTypesSelect from "./DownloadTypesSelect";
import ImportAssetsExcel from "./ImportAssetsExcel";
import axiApi from "ApiCaller";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {publishEvent} from "core/eventsConnector";
import Form from "react-bootstrap/Form";

const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";

const ModalSelectGrouped = ({show, setShow, filtering = {}, chosenIn = [], multiple = false, subtitle = ""}) => {
    const {panel} = useContext(AuthContext);
    const items = useRef({
        all: [],
        chosen: [],
    });
    const [groups, setGroups] = useState([]);
    const [zones, setZones] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [expanded, setExpanded] = useState({});
    const [expandedChosen, setExpandedChosen] = useState({});
    const [chosen, setChosen] = useState([]);
    const [message, setMessage] = useState("Seleccione los filtros necesarios.");
    const [download, setDownload] = useState("");
    const [waste, setWaste] = useState("");
    const [sumary, setsumary] = useState({island: 0, wastes: {available: 0, total: 0}});
    const filters = useRef({
        chosen: {},
    });
    const [available, setAvailable] = useState([]);

    const calcChosenCount = (chos) => {
        let total = 0;
        chos.forEach((c) => {
            if (c.is_island) {
                total += c.asset_ids.length;
            } else {
                total += 1;
            }
        });
        return total;
    };

    const calcsumary = (avail, chos) => {
        let availCount = avail.reduce((sum, i) => sum + i.assets.length, 0);
        let chosenCount = calcChosenCount(chos);
        return {island: avail.length, wastes: {available: availCount, total: availCount + chosenCount}};
    };

    const isAssetChosen = (assetId, islandId) => {
        return items.current.chosen.some((c) => {
            if (c.is_island) {
                if (c.asset_ids && c.asset_ids.length) return c.asset_ids.includes(assetId);
                return c.id === islandId;
            }
            return c.id === assetId;
        });
    };

    const loadData = () => {
        let params = {}, key;
        for (key in filters.current.chosen) {
            let val = filters.current.chosen[key];
            params[key] = Array.isArray(val) ? val[0] : val;
        }
        axiApi.get("/api/assets/islands/with-assets/", {params}).then((resp) => {
            const apiItems = resp.data.items;
            if (apiItems.length) {
                items.current.chosen.forEach((chosenItem) => {
                    if (chosenItem.is_island) {
                        const islandData = apiItems.find((i) => i.id === chosenItem.id);
                        if (islandData) {
                            if (!chosenItem.asset_ids || !chosenItem.asset_ids.length) {
                                chosenItem.asset_ids = islandData.assets.map((a) => a.id);
                            }
                            chosenItem.assets = islandData.assets;
                            chosenItem._totalAssets = islandData.assets.length;
                            chosenItem.name = islandData.name;
                            chosenItem.full_address = islandData.full_address;
                            chosenItem.lat = islandData.lat;
                            chosenItem.lng = islandData.lng;
                            chosenItem.zone_name = islandData.zone_name || "";
                        }
                    } else if (!chosenItem._parentIslandId) {
                        const parent = apiItems.find((island) =>
                            island.assets.some((a) => a.id === chosenItem.id)
                        );
                        if (parent) {
                            chosenItem._parentIslandId = parent.id;
                            chosenItem._parentIslandName = parent.name;
                            chosenItem._parentZoneName = parent.zone_name || "";
                            chosenItem._parentTotalAssets = parent.assets.length;
                        }
                    }
                });
                items.current.rawAll = apiItems.map((island) => ({
                    ...island,
                    _totalAssets: island.assets.length,
                }));
                items.current.all = items.current.rawAll.map((island) => {
                    const filteredAssets = island.assets.filter((_asset) => !isAssetChosen(_asset.id, island.id));
                    return {
                        ...island,
                        _selectedCount: island._totalAssets - filteredAssets.length,
                        assets: filteredAssets,
                    };
                }).filter((i) => i.assets.length);
                let newAvail = items.current.all;
                setAvailable([...newAvail]);
                setChosen([...items.current.chosen]);
                setsumary(calcsumary(newAvail, items.current.chosen));
                setMessage("");
            } else {
                setMessage("No se han encontrado resultados.");
                setAvailable([]);
                setsumary(calcsumary([], items.current.chosen));
            }
        });
    };

    useEffect(() => {
        axiApi.get("/api/assets/filters/").then((resp) => {
            items.current.chosen = [...chosenIn];
            setChosen([...chosenIn]);
            setGroups(resp.data.filters.groups);
            setZones(resp.data.filters.zones);
            setRoutes(resp.data.filters.routes);
            if (Object.keys(filtering).length) {
                let key;
                for (key in filtering) {
                    if (typeof filtering[key] === "string") {
                        switch (key) {
                            case "download_type":
                                filters.current.chosen[key] = [filtering[key]];
                                setDownload(filtering[key]);
                                break;
                            case "waste_type":
                                filters.current.chosen[key] = [filtering[key]];
                                setWaste(filtering[key]);
                                break;
                            default:
                                filters.current.chosen[key] = [filtering[key]];
                        }
                    } else {
                        filters.current.chosen[key] = filtering[key];
                    }
                }
                loadData();
            }
            setMessage("Seleccione filtros para buscar.");
        });
    }, []);

    const handleClose = () => {
        setShow(false);
    };
    const handleAccept = () => {
        const groups = {};
        chosen.forEach((item) => {
            if (item.is_island) {
                const key = "island_" + item.id;
                if (groups[key]) {
                    groups[key].assets.push(...(item.assets || []));
                    groups[key].asset_ids.push(...(item.asset_ids || []));
                } else {
                    groups[key] = {
                        ...item,
                        assets: [...(item.assets || [])],
                        asset_ids: [...(item.asset_ids || [])],
                    };
                }
            } else {
                const islandId = item._parentIslandId || findParentIsland(item.id)?.id;
                if (islandId) {
                    const key = "island_" + islandId;
                    if (!groups[key]) {
                        const island = items.current.rawAll?.find((i) => i.id === islandId);
                        groups[key] = {
                            is_island: true,
                            id: islandId,
                            name: item._parentIslandName || island?.name || "",
                            zone_name: item._parentZoneName || island?.zone_name || "",
                            full_address: island?.full_address || item.full_address || "",
                            lat: island?.lat || item.lat || null,
                            lng: island?.lng || item.lng || null,
                            _totalAssets: island?._totalAssets || item._parentTotalAssets || 0,
                            assets: [],
                            asset_ids: [],
                        };
                    }
                    groups[key].assets.push(item);
                    groups[key].asset_ids.push(item.id);
                } else {
                    groups["orphan_" + item.id] = item;
                }
            }
        });
        publishEvent("assets:modal:selector", {assets: Object.values(groups)});
        setShow(false);
    };

    const computeAvail = () => {
        if (!items.current.rawAll) return [];
        return items.current.rawAll.map((island) => {
            const filteredAssets = island.assets.filter((_asset) => !isAssetChosen(_asset.id, island.id));
            return {
                ...island,
                _selectedCount: island._totalAssets - filteredAssets.length,
                assets: filteredAssets,
            };
        }).filter((i) => i.assets.length);
    };

    const findParentIsland = (assetId) => {
        if (!items.current.rawAll) return null;
        for (const island of items.current.rawAll) {
            if (island.assets.some((a) => a.id === assetId)) {
                return island;
            }
        }
        return null;
    };

    const groupChosenByIsland = () => {
        if (!items.current.rawAll) return [];
        const groups = new Map();
        items.current.chosen.forEach((item, flatIdx) => {
            let islandId;
            if (item.is_island) {
                islandId = item.id;
            } else {
                islandId = item._parentIslandId;
                if (!islandId) {
                    const parent = findParentIsland(item.id);
                    islandId = parent ? parent.id : "__no_island__";
                }
            }
            if (!groups.has(islandId)) {
                let islandName = "";
                let zoneName = "";
                let totalAssets = 0;
                if (item.is_island) {
                    islandName = item.name;
                    zoneName = item.zone_name || "";
                    totalAssets = item.asset_ids?.length || item.assets?.length || 0;
                } else {
                    islandName = item._parentIslandName || "";
                    zoneName = item._parentZoneName || "";
                    totalAssets = item._parentTotalAssets || 0;
                    if (!item._parentIslandId) {
                        const parent = findParentIsland(item.id);
                        if (parent) {
                            islandName = parent.name;
                            zoneName = parent.zone_name || "";
                            totalAssets = parent.assets.length;
                            islandId = parent.id;
                        }
                    }
                }
                groups.set(islandId, {
                    islandId,
                    islandName,
                    zoneName,
                    totalAssets,
                    items: [],
                    hasFullIsland: item.is_island,
                });
            }
            const group = groups.get(islandId);
            if (item.is_island) group.hasFullIsland = true;
            group.items.push({item, flatIdx});
        });
        return [...groups.values()];
    };

    const removeIslandGroup = (islandId) => {
        items.current.chosen = items.current.chosen.filter((item) => {
            if (item.is_island) return item.id !== islandId;
            const pid = item._parentIslandId || findParentIsland(item.id)?.id;
            return pid !== islandId;
        });
    };

    const onDoubleClick = (e) => {
        if (!items.current.rawAll) return;
        let column = e.currentTarget.dataset.column;
        let idx = parseInt(e.currentTarget.dataset.idx);
        let islandId = e.currentTarget.dataset.islandId ? parseInt(e.currentTarget.dataset.islandId) : null;
        let assetId = e.currentTarget.dataset.assetId ? parseInt(e.currentTarget.dataset.assetId) : null;
        let isHeader = e.currentTarget.dataset.header === "true";

        if (column === "available") {
            let island = islandId ? items.current.rawAll.find((i) => i.id === islandId) : null;
            if (!island) return;
            if (isHeader) {
                let remaining = island.assets.filter((_ass) => !isAssetChosen(_ass.id, island.id));
                if (!remaining.length) return;
                let assetIds = remaining.map((a) => a.id);
                let islandItem = {
                    is_island: true,
                    id: island.id,
                    name: island.name,
                    full_address: island.full_address,
                    lat: island.lat,
                    lng: island.lng,
                    assets: remaining,
                    asset_ids: assetIds,
                    _totalAssets: island._totalAssets,
                };
                multiple ? items.current.chosen.push(islandItem) : (items.current.chosen = [islandItem]);
            } else {
                let itemObj = island.assets.find((a) => a.id === assetId);
                if (!itemObj) return;
                let item = {...itemObj};
                item._parentIslandId = island.id;
                item._parentIslandName = island.name;
                item._parentZoneName = island.zone_name || "";
                item._parentTotalAssets = island._totalAssets;
                multiple ? items.current.chosen.push(item) : (items.current.chosen = [item]);
            }
        } else if (e.currentTarget.dataset.group === "true") {
            if (islandId == null) return;
            removeIslandGroup(islandId);
        } else {
            let item = items.current.chosen[idx];
            if (!item) return;
            if (item.is_island) {
                items.current.chosen = items.current.chosen.filter((_, i) => i !== idx);
            } else {
                items.current.chosen = items.current.chosen.filter((_ass) => _ass.id !== item.id);
            }
        }

        let newChosen = [...items.current.chosen];
        setChosen(newChosen);
        let newAvail = computeAvail();
        setAvailable(newAvail);
        setsumary(calcsumary(newAvail, newChosen));
    };

    const deselectAll = () => {
        items.current.chosen = [];
        setChosen([]);
        if (!items.current.rawAll) {
            setAvailable([]);
            setsumary(calcsumary([], []));
            return;
        }
        let newAvail = items.current.rawAll.map((island) => ({
            ...island,
            _selectedCount: 0,
        })).filter((i) => i.assets.length);
        setAvailable(newAvail);
        setsumary(calcsumary(newAvail, []));
    };

    const applyImport = ({islands, chosen: imported}) => {
        items.current.rawAll = islands;
        items.current.chosen = imported;
        items.current.all = computeAvail();
        let newChosen = [...items.current.chosen];
        setChosen(newChosen);
        setAvailable(items.current.all);
        setsumary(calcsumary(items.current.all, newChosen));
        setMessage("");
    };

    const onSearcher = (e) => {
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        let filtered = items.current.all.map((island) => {
            let matchedAssets = island.assets.filter((_ass) => {
                let word = toLowCaseCleanSpaces(_ass.uid);
                word += toLowCaseCleanSpaces(_ass.uuids);
                word += toLowCaseCleanSpaces(fullAddressOf(_ass));
                return word.includes(valueSearched);
            });
            return {...island, assets: matchedAssets};
        }).filter((island) => island.assets.length);
        setAvailable(filtered);
        setsumary(calcsumary(filtered, items.current.chosen));
    };
    const fullAddressOf = (_ass) => _ass.full_address || "";

    const onChangeSelect = (e) => {
        const {name, value} = e.target;
        let named = name.replace("modFilter-", "");
        value ? (filters.current.chosen[named] = [value]) : delete filters.current.chosen[named];

        switch (named) {
            case "download_type":
                setDownload(value);
                break;
            case "waste_type":
                setWaste(value);
                break;
            default:
                break;
        }
    };
    const onChangeWord = (e) => {
        const {value} = e.target;
        value ? (filters.current.chosen.search = value) : delete filters.current.chosen.search;
    };

    const toggleIsland = (islandId) => {
        setExpanded((prev) => ({...prev, [islandId]: !prev[islandId]}));
    };
    const labelStyle = {width: "100%", fontWeight: "bold", textAlign: "center"};
    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} size="xl" >
                <Modal.Header closeButton className="preview-canvas mb-0 aling-items">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="dumpster" />
                    </div>
                    <div className="d-inline-flex align-items-center">
                        <Modal.Title className="d-inline-flex ms-3">
                            <div>
                                <div>Buscar Contenedores</div>
                                <div>
                                    <small className="h5">{subtitle}</small>
                                </div>
                            </div>
                        </Modal.Title>
                        <div className="d-inline-flex ms-3" role="search">
                            <input
                                className="form-control border-end-0 rounded-0"
                                type="search"
                                placeholder="uuid, dirección"
                                aria-label="Search"
                                onChange={onSearcher}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0" id="searcher-icon">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                            </span>
                        </div>
                        <div className="d-inline-flex ms-3">Selecciona/Deselecciona con doble click.</div>
                    </div>
                </Modal.Header>
                <Modal.Body className="bg-light">
                    <div className="container-fluid">
                        <div className="row selector-multiple-cards">
                            <div className="col-12 mt-3">
                                <div className="row">
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <div className="mb-3">
                                            <label htmlFor="word" style={labelStyle}>
                                                UUID, UID
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="word"
                                                placeholder="UUID, UID"
                                                onChange={onChangeWord}
                                            />
                                        </div>
                                    </div>
                                    <div className="col" style={{maxWidth: "160px"}}>
                                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>Descarga</label>
                                        <DownloadTypesSelect
                                            multiple={true}
                                            prefix="modFilter-"
                                            value={download}
                                            disabled={"download_type" in filtering}
                                            onChange={onChangeSelect}
                                        />
                                    </div>
                                    <div className="col" style={{maxWidth: "160px"}}>
                                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>Fracción</label>
                                        <WasteTypesSelect
                                            multiple={true}
                                            prefix="modFilter-"
                                            value={waste}
                                            onChange={onChangeSelect}
                                            disabled={"waste_type" in filtering}
                                        />
                                    </div>
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <label style={labelStyle}>Grupos</label>
                                        <Form.Select
                                            aria-label="Selector de tipos de residuos"
                                            name="modFilter-group"
                                            onChange={onChangeSelect}
                                            defaultValue="">
                                            <option value="">Todos</option>
                                            {groups.map((_it, index) => (
                                                <option value={_it.id} key={index}>
                                                    {_it.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <label style={labelStyle}>Zonas</label>
                                        <Form.Select
                                            aria-label="Selector de tipos de residuos"
                                            name="modFilter-zone"
                                            onChange={onChangeSelect}
                                            defaultValue="">
                                            <option value="">Todos</option>
                                            {zones.map((_it, index) => (
                                                <option value={_it.id} key={index}>
                                                    {_it.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <label style={labelStyle}>Rutas</label>
                                        <Form.Select
                                            aria-label="Selector de rutas"
                                            name="modFilter-route"
                                            onChange={onChangeSelect}
                                            defaultValue="">
                                            <option value="">Todos</option>
                                            {routes.map((_it, index) => (
                                                <option value={_it.id} key={index}>
                                                    {_it.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                    <div className="col" style={{maxWidth: "110px"}}>
                                        <button type="button" className="btn btn-outline-secondary mt-4" onClick={loadData}>
                                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Buscar
                                        </button>
                                    </div>
                                    {multiple && (
                                        <div className="col" style={{maxWidth: "180px"}}>
                                            <ImportAssetsExcel filtering={filtering} onImport={applyImport} />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6 col-12 available mt-3">
                                <div className="d-flex align-items-center mb-2">
                                    <h4 className="mb-0">Disponibles</h4>
                                    <div className="ms-auto text-muted small">
                                        {sumary.wastes.available}/{sumary.wastes.total} contenedor(es) en {sumary.island} isla(s)
                                    </div>
                                </div>
                                <div className="selector-scrollable p-2 border" >
                                    {available.length ? (
                                        available.map((island, islandIdx) => (
                                            <div key={island.id} className="mb-2">
                                                 <div
                                                    className="d-flex align-items-center border rounded p-2 bg-white prevent-select"
                                                    role="button"
                                                    data-idx={0}
                                                    data-island-id={island.id}
                                                    data-column="available"
                                                    data-header="true"
                                                    onDoubleClick={onDoubleClick}
                                                    style={{cursor: "pointer"}}>
                                                    <FontAwesomeIcon
                                                        icon={expanded[island.id] ? "chevron-down" : "chevron-right"}
                                                        className="me-2"
                                                        role="button"
                                                        onClick={(e) => { e.stopPropagation(); toggleIsland(island.id); }}
                                                        style={{cursor: "pointer"}}
                                                    />
                                                    <img src={`${urlStatic}/images/icons/waypoints/1-island.svg`} height={32} className="me-2" role="button" onClick={(e) => { e.stopPropagation(); toggleIsland(island.id); }} style={{cursor: "pointer"}} alt="Isla" />
                                                    <div className="fw-bold" role="button" onClick={(e) => { e.stopPropagation(); toggleIsland(island.id); }} style={{cursor: "pointer"}}>{island.name}</div>
                                                    <div className="ms-2 text-muted small">
                                                        {island.zone_name && `(${island.zone_name})`}
                                                    </div>
                                                    <div className="ms-2 text-muted small text-truncate" style={{maxWidth: "200px"}}>
                                                        {island.full_address}
                                                    </div>
                                                    <div className="ms-auto text-muted small">
                                                        {island._selectedCount > 0
                                                            ? `${island._selectedCount}/${island._totalAssets} seleccionados`
                                                            : `${island.assets.length} contenedor(es)`}
                                                    </div>
                                                </div>
                                                {expanded[island.id] && (
                                                    <ul className="list-unstyled ms-3 mt-1">
                                                        {island.assets.map((_asset, idx) => (
                                                            <li
                                                                className="border rounded p-2 mb-1 bg-white prevent-select"
                                                                role="button"
                                                                 key={_asset.id}
                                                                 data-idx={idx}
                                                                 data-island-id={island.id}
                                                                 data-asset-id={_asset.id}
                                                                 data-column="available"
                                                                 onDoubleClick={onDoubleClick}>
                                                                <AssetBasic asset={_asset} />
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-center h5 p-3">{message}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6 col-12 selected mt-3 d-flex flex-column">
                                <div className="d-flex align-items-center mb-2">
                                    <h4 className="mb-0">Seleccionados</h4>
                                    <div className="ms-auto text-muted small">
                                        {calcChosenCount(chosen)}/{sumary.wastes.total} contenedor(es)
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary ms-2"
                                        title="Borra los seleccionados"
                                        onClick={deselectAll}
                                        style={{lineHeight: 1}}>
                                        <FontAwesomeIcon icon="trash" />
                                    </button>
                                </div>
                                <div className="selector-scrollable p-2 bg-white" >
                                    <ul className="list-unstyled">
                                        {chosen.length ? (
                                            items.current.rawAll ? (
                                                (() => {
                                                    const chosenGroups = groupChosenByIsland();
                                                    return chosenGroups.map((group) => (
                                                        <li key={"group-" + group.islandId} className="mb-2">
                                                            <div
                                                                className="d-flex align-items-center border rounded p-2 bg-white prevent-select"
                                                                role="button"
                                                                data-column="selected-group"
                                                                data-island-id={group.islandId}
                                                                data-group="true"
                                                                onDoubleClick={onDoubleClick}
                                                                style={{cursor: "pointer"}}>
                                                                <FontAwesomeIcon
                                                                    icon={expandedChosen[group.islandId] ? "chevron-down" : "chevron-right"}
                                                                    className="me-2"
                                                                    role="button"
                                                                    onClick={(e) => { e.stopPropagation(); setExpandedChosen((prev) => ({...prev, [group.islandId]: !prev[group.islandId]})); }}
                                                                    style={{cursor: "pointer"}}
                                                                />
                                                                <img src={`${urlStatic}/images/icons/waypoints/1-island.svg`} height={32} className="me-2" role="button" onClick={(e) => { e.stopPropagation(); setExpandedChosen((prev) => ({...prev, [group.islandId]: !prev[group.islandId]})); }} style={{cursor: "pointer"}} alt="Isla" />
                                                                <div className="fw-bold" role="button" onClick={(e) => { e.stopPropagation(); setExpandedChosen((prev) => ({...prev, [group.islandId]: !prev[group.islandId]})); }} style={{cursor: "pointer"}}>{group.islandName}</div>
                                                                <div className="ms-2 text-muted small">
                                                                    {group.zoneName && `(${group.zoneName})`}
                                                                </div>
                                                                <div className="ms-auto text-muted small">
                                                                    {group.items.reduce((sum, {item}) => sum + (item.is_island ? (item.assets?.length || 0) : 1), 0)}{group.totalAssets ? `/${group.totalAssets}` : ""} contenedor(es)
                                                                </div>
                                                            </div>
                                                            {expandedChosen[group.islandId] && group.items.length > 0 && (
                                                                <ul className="list-unstyled ms-3 mt-1">
                                                                     {group.items.map(({item, flatIdx}) =>
                                                                        item.is_island ? (
                                                                            (item.assets || []).map((child) => (
                                                                                <li key={child.id} className="border rounded p-2 mb-1 bg-white">
                                                                                    <AssetBasic asset={child} />
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <li
                                                                                key={item.id}
                                                                                className="border rounded p-2 mb-1 bg-white prevent-select"
                                                                                role="button"
                                                                                data-idx={flatIdx}
                                                                                data-column="selected"
                                                                                onDoubleClick={onDoubleClick}
                                                                                style={{cursor: "pointer"}}>
                                                                                <AssetBasic asset={item} />
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    ));
                                                })()
                                            ) : (
                                                chosen.map((_asset, idx) => (
                                                    _asset.is_island ? (
                                                        <li key={"island-" + idx} className="mb-2">
                                                            <div
                                                                className="d-flex align-items-center border rounded p-2 bg-white prevent-select"
                                                                role="button"
                                                                data-idx={idx}
                                                                data-column="selected"
                                                                onDoubleClick={onDoubleClick}
                                                                style={{cursor: "pointer"}}>
                                                                <FontAwesomeIcon
                                                                    icon={expandedChosen[_asset.id] ? "chevron-down" : "chevron-right"}
                                                                    className="me-2"
                                                                    role="button"
                                                                    onClick={(e) => { e.stopPropagation(); setExpandedChosen((prev) => ({...prev, [_asset.id]: !prev[_asset.id]})); }}
                                                                    style={{cursor: "pointer"}}
                                                                />
                                                                <img src={`${urlStatic}/images/icons/waypoints/1-island.svg`} height={32} className="me-2" role="button" onClick={(e) => { e.stopPropagation(); setExpandedChosen((prev) => ({...prev, [_asset.id]: !prev[_asset.id]})); }} style={{cursor: "pointer"}} alt="Isla" />
                                                                <div className="fw-bold" role="button" onClick={(e) => { e.stopPropagation(); setExpandedChosen((prev) => ({...prev, [_asset.id]: !prev[_asset.id]})); }} style={{cursor: "pointer"}}>{_asset.name}</div>
                                                                <div className="ms-2 text-muted small">
                                                                    {_asset.zone_name && `(${_asset.zone_name})`}
                                                                </div>
                                                                <div className="ms-2 text-muted small text-truncate" style={{maxWidth: "200px"}}>
                                                                    {_asset.full_address}
                                                                </div>
                                                                <div className="ms-auto text-muted small">
                                                                    {(_asset.assets || []).length} contenedor(es)
                                                                </div>
                                                            </div>
                                                            {expandedChosen[_asset.id] && (_asset.assets || []).length > 0 && (
                                                                <ul className="list-unstyled ms-3 mt-1">
                                                                    {(_asset.assets || []).map((child) => (
                                                                        <li key={child.id} className="border rounded p-2 mb-1 bg-white">
                                                                            <AssetBasic asset={child} />
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    ) : (
                                                        <li
                                                            className="border rounded p-2 mb-3 bg-white prevent-select"
                                                            role="button"
                                                            key={idx}
                                                            data-idx={idx}
                                                            data-column="selected"
                                                            onDoubleClick={onDoubleClick}>
                                                            <AssetBasic asset={_asset} />
                                                        </li>
                                                    )
                                                ))
                                            )
                                        ) : (
                                            <li className="text-center h5">Ningún contenedor seleccionado</li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                     <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Descartar
                        </Button>
                     <Button variant="primary" onClick={handleAccept}>
                         Seleccionar
                     </Button>
                 </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalSelectGrouped;